/*
 * GearFrost sticky add-to-cart bar.
 * - Shows the bar (CSS class .is-visible) only while the real product ATC button is scrolled
 *   out of view (IntersectionObserver on #ProductSubmitButton-{sectionId}).
 * - The bar's button just clicks the real Dawn submit button, so Dawn's product-form handles
 *   the actual /cart/add + cart drawer/notification (no duplicated add logic).
 * - Subscribes to Dawn's variantChange pub/sub to keep the price (incl. the SAVE badge) and the
 *   button's availability in sync with the variant picker.
 */
if (!customElements.get('gf-sticky-atc')) {
  customElements.define(
    'gf-sticky-atc',
    class GfStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('.gf-sticky-atc__button');
        this.priceEl = this.querySelector('.gf-sticky-atc__price');
        this.variantEl = this.querySelector('.gf-sticky-atc__variant');
        this.realSubmitId = 'ProductSubmitButton-' + this.sectionId;

        if (this.button) {
          this.button.addEventListener('click', () => {
            const real = document.getElementById(this.realSubmitId);
            if (real && !real.hasAttribute('disabled')) real.click();
          });
        }

        // Reveal the bar only when the real ATC button is not in the viewport.
        const realSubmit = document.getElementById(this.realSubmitId);
        if (realSubmit && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible = !entry.isIntersecting;
                this.classList.toggle('is-visible', visible);
                // lift the sales-pop toast above the bar while it is showing
                document.body.classList.toggle('gf-sticky-atc-open', visible);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(realSubmit);
        }

        // Keep price + availability synced with the variant picker.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event && event.data;
            if (!data || data.sectionId !== this.sectionId) return;
            const newPrice = data.html && data.html.getElementById('price-' + this.sectionId);
            if (newPrice && this.priceEl) this.priceEl.innerHTML = newPrice.innerHTML;
            if (this.variantEl && data.variant && data.variant.title) {
              this.variantEl.textContent = data.variant.title;
            }
            if (this.button) {
              this.button.disabled = !data.variant || data.variant.available === false;
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantUnsubscribe) this.variantUnsubscribe();
      }
    }
  );
}
